import React, { Component } from "react";

export class BombIndicator extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    render() {
        return (
			<div className="BombIndicator" style={{left: this.props.pos.x-this.props.size.width/2, top: this.props.pos.y-this.props.size.height/2, position:'absolute', width: this.props.size.width, height: this.props.size.height}}>
			</div>
        );
    }
}

export default BombIndicator;
